module.exports = __webpack_public_path__ + "static/media/webroll.f2f31090.mp4";